import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=8e4dc43a&scoped=true"
import script from "./InquiryList.vue?vue&type=script&lang=js"
export * from "./InquiryList.vue?vue&type=script&lang=js"
import style0 from "./InquiryList.vue?vue&type=style&index=0&id=8e4dc43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4dc43a",
  null
  
)

export default component.exports